export default class TabbedBlockController {
    constructor() {
        this.container;
        this.allAccordionLabels;
        this.allDesktopButtons;

        this.init();
    }

    init() {
        if (document.querySelector('.fase2.tabbedInfoBlock')) {
            document.querySelectorAll('.fase2.tabbedInfoBlock').forEach(container => {
                this.container = container;
                this.allAccordionLabels = this.container.querySelectorAll('.accordion>li');
                this.allDesktopButtons = this.container.querySelectorAll('.labelsDesktop li button');
                console.log(this.allAccordionLabels);
                console.log(this.allDesktopButtons);

                this.eventListeners();

                // container.querySelectorAll(".labelsDesktop li button").forEach((button, index) => {
                //     button.addEventListener('click', () => {
                //         this.resetActiveButtons(container);
                //         button.classList.add('active');
                //         this.allAccordionLabels[index].click();
                //     })
                // })
                // allAccordionLabels.forEach((label, index) => {
                //     label.addEventListener('click', () => {
                //         this.resetActiveButtons(container);

                //     })
                // })
            })
        }
    }

    eventListeners(){
        this.allDesktopButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                console.log(this.allAccordionLabels, this.allAccordionLabels[index].getAttribute('aria-expanded'), this.allAccordionLabels[index], index);
                if(this.allAccordionLabels[index].getAttribute('aria-expanded') == 'false'){
                    console.log('click');
                    this.allAccordionLabels[index].querySelector('.header').click();
                    this.setActiveDesktopButton();
                }
                
            })
            
        })
    }

    setActiveDesktopButton(){
        this.allDesktopButtons.forEach(button => {
            if (button.classList.contains('active')){
                button.classList.remove('active');
            }
        })

        this.allAccordionLabels.forEach((li, index) => {
            if(li.getAttribute('aria-expanded') == 'true'){
                this.allDesktopButtons[index].classList.add('active');
            }
        })
    }
}